import ApiService from "./api_service";

const resource = "o/token/"
export default {
    async post(payload) {
        return await ApiService.call('post', `${resource}`, payload);
    }
}